import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import StateSpinner, { useResourceLoadingStateIndicatorProps } from '../../../../resources/components/StateSpinner.js';
import { useResourceDataContext } from '../../context/resourceDataContext.js';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import Tooltip from '@fabric-app/ui/components/Tooltip';

const StyledSpinnerContainer = styled.div.withConfig({
  displayName: "ProcessingIndicator__StyledSpinnerContainer",
  componentId: "sc-e06f0369-0"
})([
  ``,
  `{margin-left:0px;margin-right:0;}`
], mediaMobile);
const ProcessingIndicator = () => {
  const { resource } = useResourceDataContext();
  const { isIndexing, showIndicator } = useResourceLoadingStateIndicatorProps(resource);
  return showIndicator ? /* @__PURE__ */ jsx(StyledSpinnerContainer, {
    children: /* @__PURE__ */ jsx(Tooltip, {
      label: "Waiting to be indexed and analyzed by AI",
      children: /* @__PURE__ */ jsx(StateSpinner, {
        size: 22,
        thickness: 3,
        isIndexing
      })
    })
  }) : null;
};

export { ProcessingIndicator };
//# sourceMappingURL=ProcessingIndicator.js.map
